const DependencyType = {
    ApolloClient: Symbol.for('ApolloClient'),
    SearchService: Symbol.for('SearchService'),
    AuthService: Symbol.for('AuthService'),
};

export default DependencyType;
